import type * as Types from 'app/types/graphql';

export type PageSnapshotSelectFragment = Pick<
  Types.PageSnapshot,
  'hash' | 'presignedURL' | 'thumbnail' | 'createdAt' | 'campaignVariantType'
>;

export const PageSnapshotSelectFragmentDoc = `
    fragment PageSnapshotSelect on PageSnapshot {
  hash
  presignedURL
  thumbnail
  createdAt
  campaignVariantType
}
    `;
